module.exports = __webpack_public_path__ + "static/media/camera-XL.inline.988bd4aa.svg";